"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gerenciatdReact = _interopRequireDefault(require("@bit/gerenciatd.react.link-over-box-container"));

var _gerenciatdReact2 = _interopRequireDefault(require("@bit/gerenciatd.react.link-over-box"));

require("./Icon.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Stateless component to draw an icon.
 * @param {string} classIcon CSS class name for icon, must exist in icoFonts.scss.
 * @param {string} wrapperClass CSS class name for the wrapper div of icon and label.
 * @param {bool} badge Sets if the icon has a red dot.
 * @param {string} label Icon's label.
 * @param {string} title Title on wrapper.
 * @param {func} onClick Function executed by clicking the icon.
 * @returns {JSX} Component JSX.
 */
var Icon = /*#__PURE__*/function (_Component) {
  _inherits(Icon, _Component);

  var _super = _createSuper(Icon);

  function Icon() {
    var _this;

    _classCallCheck(this, Icon);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleClick", function () {
      _this.props.onClick();
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyPress", function (evt) {
      var code = evt.keyCode || evt.which;

      if (code === 13) {
        _this.handleClick(evt);
      }
    });

    return _this;
  }

  _createClass(Icon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classIcon = _this$props.classIcon,
          wrapperClass = _this$props.wrapperClass,
          label = _this$props.label,
          title = _this$props.title,
          link = _this$props.link,
          target = _this$props.target,
          labelOutside = _this$props.labelOutside,
          managementValue = _this$props.managementValue,
          taggingClass = _this$props.taggingClass,
          id = _this$props.id,
          onClick = _this$props.onClick; // JSX to create the Icon Component visualization

      var labels = '';
      var variousLines = false;

      if (label.indexOf('<br/>') > -1) {
        labels = label.split('<br/>');
        variousLines = true;
      }

      var getFinalIconLabel = function getFinalIconLabel() {
        if (variousLines) {
          return labels.map(function (labelito, index) {
            var genIndex = "".concat(index);
            return /*#__PURE__*/_react["default"].createElement("span", {
              key: genIndex,
              className: "iconLabel variousLines iconLabel-".concat(index)
            }, labelito.replace('<br />', ''));
          });
        } else {
          return /*#__PURE__*/_react["default"].createElement("span", {
            className: "iconLabel iconLabelUnique"
          }, label);
        }
      };

      return /*#__PURE__*/_react["default"].createElement("div", {
        title: title,
        className: "iconWrapper ".concat(wrapperClass),
        role: "button",
        tabIndex: "-1",
        onClick: this.handleClick,
        onKeyPress: this.handleKeyPress
      }, link && /*#__PURE__*/_react["default"].createElement(_gerenciatdReact["default"], null, /*#__PURE__*/_react["default"].createElement("span", {
        className: "icon ".concat(classIcon, " ").concat(taggingClass)
      }), label && /*#__PURE__*/_react["default"].createElement(_gerenciatdReact2["default"], {
        managementValue: managementValue,
        id: id,
        onClick: onClick,
        target: target,
        link: link,
        alt: title,
        component: "icono"
      }, getFinalIconLabel()), !label && /*#__PURE__*/_react["default"].createElement(_gerenciatdReact2["default"], {
        managementValue: managementValue,
        id: id,
        onClick: onClick,
        target: target,
        link: link,
        alt: title,
        component: "icono"
      })), !link && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
        className: "icon ".concat(classIcon, " ").concat(taggingClass)
      }), getFinalIconLabel()), labelOutside && /*#__PURE__*/_react["default"].createElement("span", {
        className: "iconLabel iconLabelOutside"
      }, labelOutside));
    }
  }]);

  return Icon;
}(_react.Component); // Proptypes for the Icon props


Icon.propTypes = {
  classIcon: _propTypes["default"].string.isRequired,
  wrapperClass: _propTypes["default"].string,
  taggingClass: _propTypes["default"].string,
  target: _propTypes["default"].string,
  label: _propTypes["default"].string,
  title: _propTypes["default"].string.isRequired,
  link: _propTypes["default"].string,
  onClick: _propTypes["default"].func
}; // Default values for non required props

Icon.defaultProps = {
  taggingClass: '',
  label: '',
  target: '_self',
  wrapperClass: '',
  link: '',
  onClick: function onClick() {}
};
var _default = Icon;
exports["default"] = _default;

//# sourceMappingURL=index.js.map